import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import { ControllerContainer } from "@stubhub/react-store-provider";

import produceController from "./controller";
import messages from "./messages";

import { default as EventListPanel } from "./index";

export const sortOptions = [
  {
    key: "date",
    value: {
      sort: "eventDateLocal asc",
      reRankBy: "relevance",
    },
  },
  {
    key: "distance",
    value: {
      sort: "distance asc,eventDateLocal asc",
      reRankBy: "relevance",
    },
  },
  {
    key: "popularity",
    value: {
      sort: "trending desc",
      reRankBy: "relevance",
    },
  },
  {
    key: "parkingpass",
    value: {
      sort: null,
      reRankBy: "parking",
    },
  },
];

function translateOptions(intl) {
  return sortOptions.map((s) => {
    let _s = { ...s };
    _s.name = intl.formatMessage(messages[_s.key]);

    return _s;
  });
}

class EventListPanelContainer extends Component {
  constructor(props, context) {
    super(props, context);
    let { disableSortFilter } = props;
    this.sortOptions = disableSortFilter
      ? []
      : translateOptions(this.props.intl);
  }

  render() {
    let childProps = { ...this.props };
    delete childProps.intl; // Child component doesn't need intl prop, which may cause rerender

    return (
      <ControllerContainer
        component={EventListPanel}
        factory={produceController}
        sortOptions={this.sortOptions}
        {...childProps}
      />
    );
  }
}

EventListPanelContainer.propTypes = {
  /**
   * Boolean Flag to Disable the Sort Filter from Rendering for this Event List Component Instance.
   *
   */
  disableSortFilter: PropTypes.bool,
  defaultSort: PropTypes.string,
  sortOptions: PropTypes.array,
  intl: PropTypes.object,
  id: PropTypes.any, // Used to check if need to reset the component
  includeRadius: PropTypes.bool,
};
EventListPanelContainer.defaultProps = {
  disableSortFilter: false,
  defaultSort: "date",
  includeRadius: true,
};

export default injectIntl(EventListPanelContainer);
